import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { SiteService } from "../../services/site.service";
import { Site } from "../../types/Site";
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { Production } from '../../types/Production';
import { SubRegion } from '../../types/SubRegion';
import { NotificationService } from "../../../common/component/notification/notification.service";
import { CompanySite } from "../../types/CompanySite";
import { SAPPlant } from '../../types/SAPPlant';
import { SharedService } from "../../../services/SharedService";
import { LookupService } from 'src/app/common/service/lookup.service';
import { ProductionVolumeUom } from "../../types/ProductionVolumeUom";
import { Coordinates, GeocodeRequest } from "../../types/Location";
import { Lookup } from 'src/app/common/model/lookup';
import { ProspectListItem } from 'src/app/equipments/services/equipment.service';
import { PlantInfo } from '../../types/PlantInfo';
import { ProdVolHistory } from '../../types/ProdVolHistory';
import { SharedComponentService } from 'src/app/common/service/sharedcomponent.service';
import { ProvinceData } from '../../types/ProvinceData';
import { Country } from '../../types/Country';
import { BatchReportsService } from 'src/app/reports/batch-reports-grid/batch-reports-service';

@Component({
  selector: 'app-editsite',
  templateUrl: './editsite.component.html',
  styleUrls: ['./editsite.component.scss']
})
export class EditSiteComponent implements OnInit {
  modes = [];
  title: string;
  siteId: number;
  SiteData: Site;
  ProductionData: Production;
  CompanySiteData: CompanySite[];
  prodVolHistoryData: ProdVolHistory[];
  PlantInfo: PlantInfo = {
    SiteData: new Site,
    ProductionData: new Production,
    CompanySites: [],
    Prodvolhistories: [],
    realPlant: false
  };
  SubRegions: SubRegion[];
  SAPPlants: SAPPlant[];
  ProductUnitsDataSource: DataSource<any, any>;
  siteNamesDataSource: DataSource;
  siteNamesArray: any[];
  isLoadPanelVisible = true;
  LocalCompniesArray: any[];
  localCompniesDataSource: DataSource<any, any>;
  CountiesArray: Country[];
  countiesDataSource: DataSource<any, any>;
  provinceDataSource: ProvinceData[];
  citiesArray: any[];
  citiesDataSource: DataSource<any, any>;
  subRegionDataSource: DataSource<any, any>;
  SAPgridBoxValue: String[] = [];
  realTemporaryPlatOptions: Lookup[] = [];
  SAPgridDataSource: any;
  isSAPGridBoxOpened: boolean = false;
  isLatitudeChanged: boolean = false;
  productsReadOnly: boolean = true;
  realPlant: boolean = false;
  isPlantSite: boolean = true;
  SAPgridColumns: any = ['SAP Plant ID', 'Plant Name'];
  isMerchant: string = "Merchant";
  isTonnage: string = "Tonnage";
  isBoth: string = "isBoth";
  currentPlantMode: string;
  realTemporaryPlantOption: string;
  canAddEditRealPlant: boolean;
  canAddEditProposedPlant: boolean;
  liquifierTypeDataSource: DataSource<any, any>;
  SourceTypeDataSource: ProspectListItem[];
  localCompanyTypesDataSource: DataSource<any, any>;
  industrialZonesDataSource: DataSource<any, any>;
  provinceArray: any;
  franchiseDataSource: DataSource<any, any>;
  paddnameDataSource: DataSource<any, any>;
  prodVolUOMList: ProductionVolumeUom[];
  settingDefault: boolean = false;
  showReqFieldsWarning: boolean = false;
  selectedPlantMode: string;
  popupVisible: boolean;
  siteType: string;
  numberPattern: any = /^(0|[1-9][0-9]*)$/;
  isSaveCloseClicked: boolean = false;
  isSubmitClicked = false;
  gasFlagForGeoCalcuation: boolean = false;
  productsValidated: boolean = true;
  companyOwnershipAdded: boolean = true;
  Coordinates: Coordinates;
  mapsPopupVisible: boolean;
  okayCancelDialogVisible: boolean;
  volumePopupVisible: boolean;
  createCompanySite: boolean;
  message: string;
  eventkey: string;
  isClose: boolean;
  isNewSite: boolean;

  constructor(private siteSvc: SiteService,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private lookupService: LookupService,
    private sharedSvc: SharedService,
    private notificationService: NotificationService,
    private sharedComponentService: SharedComponentService,
    private batchReportsService: BatchReportsService) {
    this.modes = [{ text: this.isMerchant, value: "M" }, { text: this.isTonnage, value: "T" }];
    this.validatePlantType = this.validatePlantType.bind(this);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.siteId = params['id'];
        this.GetPlantDetailsForSiteId(this.siteId);
        this.GetCompanyOwnersForSiteId(this.siteId);
        this.isNewSite = false;
      }
      else {
        if (this.siteId === undefined || this.siteId === null) {
          this.siteId = -1;
          this.isNewSite = true;
        }
        this.SiteData = new Site();
        this.ProductionData = new Production();
        this.CompanySiteData = [];
        this.prodVolHistoryData = [];
        this.GetAllCountries();
        this.GetSAPPlantList();
      }
    });
    this.lookupService.getLookupValues('RealTemporaryPlant')
      .subscribe(
        (data: Lookup[]) => {
          this.realTemporaryPlatOptions = data;
          this.checkRealPlant();
        }
      );
    this.GetLiquifierTypeList();
    this.GetAllLocalCompanyTypes();
    this.GetAllIndustrialZones();
    this.GetAllFranchises();
    this.GetAllPADDNames();
    this.GetPlantUnits();
    this.sharedComponentService.sendEvent();
    this.isLoadPanelVisible = false;
  }

  onRealTemporaryPlantOptionsChanged(e) {
    this.realTemporaryPlantOption = e.value;
    this.checkRealPlant();
  }

  checkRealPlant() {
    if ((this.currentPlantMode !== "T" && this.currentPlantMode !== undefined) && (this.realTemporaryPlantOption !== "Real" && this.realTemporaryPlantOption !== undefined)) {
      this.productsReadOnly = false;
    } else {
      this.productsReadOnly = true;
    }

    if (this.realTemporaryPlantOption === "Real") {
      this.realPlant = true;
    } else {
      this.realPlant = false;
    }

    if (this.realTemporaryPlantOption === "Real" && !this.sharedSvc.UserRoles?.isIGAdmin && !this.sharedSvc.UserRoles?.isTGEEAdmin) {
      this.canAddEditRealPlant = false;
      this.notificationService.alert("warning", "Please contact the administrator to get access to add/edit real plants", null);
    } else {
      this.canAddEditRealPlant = true;
    }

    if (this.realTemporaryPlantOption === "Proposed" && !this.sharedSvc.UserRoles?.isIGAdmin && !this.sharedSvc.UserRoles?.isTGEEAdmin && !this.sharedSvc.UserRoles?.isIGPower && !this.sharedSvc.UserRoles?.isTGEEPower) {
      this.canAddEditProposedPlant = false;
      this.notificationService.alert("warning", "Please contact the administrator to get access to add/edit proposed plants", null);
    } else {
      this.canAddEditProposedPlant = true;
    }
  }


  GetPlantDetailsForSiteId(siteId) {
    this.siteSvc.GetPlantDetailsForSiteId(siteId).subscribe({
      next: data => {
        this.SiteData = data;
        this.currentPlantMode = this.SiteData.plantBusiness;
        this.GetAllCountries();
        this.GetAllProvinces(this.SiteData.countryId);
        this.GetAllCities(this.SiteData.statProvId);
        this.GetProductionDetailsForSiteId(this.siteId);
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Site Details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetProductionDetailsForSiteId(siteId) {
    this.siteSvc.GetProductionDetailsForSiteId(siteId).subscribe({
      next: data => {
        this.ProductionData = data;
        this.SAPgridBoxValue.push(data.sapplantId);
        if (this.ProductionData.plantStatus === "Real") {
          this.realPlant = true;
        }
        this.realTemporaryPlantOption = this.ProductionData.plantStatus;
        this.GetSAPPlantList();
        this.checkRealPlant();
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Production Details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetPlantUnits() {
    this.siteSvc.GetAllProdVolUOMList().subscribe({
      next: data => {
        this.prodVolUOMList = data;
        this.ProductUnitsDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'name',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching plant modes", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetCompanyOwnersForSiteId(siteId) {
    this.siteSvc.GetCompanyOwnersForSiteId(siteId).subscribe({
      next: data => {
        let totalpercent = 0;
        if (data.length > 0) {
          data.forEach(element => {
            totalpercent = totalpercent + Number(element.companyOwnerSharePercent);
          });
          data.push({ companyName: "Total", companyOwnerSharePercent: totalpercent, companyId: 0, siteId: 0 });
        }
        this.CompanySiteData = data.sort(x => x.companyOwnerSharePercent);
        this.PlantInfo.CompanySites = this.CompanySiteData;

      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Company Owners Details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetSubRegions(region) {
    this.siteSvc.GetSubRegions(region).subscribe({
      next: data => {
        this.SubRegions = data;
        this.subRegionDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'subRegion1',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching SubRegion Details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllCountries() {
    this.siteSvc.GetAllCountries().subscribe({
      next: data => {
        this.CountiesArray = data;
        this.countiesDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'countryName',
          },
        });
        if (this.SiteData.countryId) {
          let countrydetails = this.CountiesArray.filter(x => x.countryId == this.SiteData.countryId)[0];
          this.GetSubRegions(countrydetails.worldRegion);
        }
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching all countries", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllProvinces(countryId) {
    this.siteSvc.GetAllProvinces(countryId).subscribe({
      next: data => {
        this.provinceArray = data;
        this.provinceDataSource = data;
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching proviences", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllCities(province) {
    this.siteSvc.GetAllCities(province).subscribe({
      next: data => {
        this.citiesArray = data;
        this.citiesDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'city',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching cities", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetSAPPlantList() {
    this.siteSvc.GetSAPPlantList().subscribe({
      next: data => {
        this.SAPPlants = data;
        this.SAPgridDataSource = new CustomStore({
          loadMode: 'raw',
          key: 'sapplantId',
          load() {
            return data;
          },
        });
        this.SAPgridBoxValue.push(this.ProductionData.sapplantId);
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching SAP Plants Details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetLiquifierTypeList() {
    this.siteSvc.GetLiquifierTypeList().subscribe({
      next: data => {
        this.liquifierTypeDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'typeLiquidId',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Liquifier Type Details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllLocalCompanyTypes() {
    this.siteSvc.GetAllLocalCompanyTypes().subscribe({
      next: data => {
        this.localCompanyTypesDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'localCompanyType',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching local company type details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllIndustrialZones() {
    this.siteSvc.GetAllIndustrialZones().subscribe({
      next: data => {
        this.industrialZonesDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'industrialZoneID',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching industrial zones details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllFranchises() {
    this.siteSvc.GetAllFranchises().subscribe({
      next: data => {
        this.franchiseDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'franchiseId',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching franchise details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  GetAllPADDNames() {
    this.siteSvc.GetAllPADDNames().subscribe({
      next: data => {
        this.paddnameDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'name',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching franchise details", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  onSAPGridBoxOptionChanged(e) {
    if (e.name === 'value') {
      this.isSAPGridBoxOpened = false;
      this.ref.detectChanges();
    }
  }

  gridBox_displayExpr(item) {
    return item && `${item.sapplantId} <${item.plantName}>`;
  }

  addCustomItem(data, _datasource: DataSource, propertyName: string) {
    if (!data.text) {
      data.customItem = null;
      return;
    }
    var newItem = {};

    newItem[propertyName] = data.text;

    data.customItem = _datasource.store().insert(newItem)
      .then(() => _datasource.load())
      .then(() => newItem)
      .catch((error) => {
        throw error;
      });
  }

  OnCountrySelected() {
    if (!this.SiteData.countryId) return;

    this.SiteData.statProvId = null;
    this.SiteData.city = null;
    this.GetAllProvinces(this.SiteData.countryId);
    let countrydetails = this.CountiesArray.filter(x => x.countryId == this.SiteData.countryId)[0];
    this.GetSubRegions(countrydetails.worldRegion);
  }

  OnProvienceSelected() {
    if (!this.SiteData.statProvId) return;

    this.SiteData.city = null;
    this.GetAllCities(this.SiteData.statProvId);
  }

  onModeValueChanged($event) {
    this.currentPlantMode = $event.value;
    if ($event.value == "M") {
      this.title = "Add/Edit Plants (Merchant only)";
    }
    else if ($event.value == "T") {
      this.title = "Add/Edit Plants (Tonnage only)";
    }
    else {
      this.title = "Add/Edit Plants";
    }

    this.checkRealPlant();

  }

  onPlantModeValueChanged($event) {
    const item = this.realTemporaryPlatOptions.find(e => e.value === $event.value);
    if ($event.value === 'Proposed') {
      if (!(this.sharedSvc.UserRoles && (this.sharedSvc.UserRoles.isIGAdmin || this.sharedSvc.UserRoles.isTGEEAdmin))) {
        this.notificationService.alert("warning", "Only Admin can add or access proposed plants.", null);
        this.ProductionData.plantStatus = null;
      }
    }
  }

  ConvertUnit(UOM, fieldname): number {
    let factor = this.prodVolUOMList.filter(x => x.name == "shortTPD")[0].multiplierToGetMtd;
    if (UOM == "shortTPD") {
      var sUnit = Number(this.ProductionData[fieldname]) * Number(factor);
      return Math.round(sUnit);
    }
    else {
      var mUnit = Number(this.ProductionData[fieldname]) * 1 / Number(factor);
      return Math.round(mUnit);
    }
  }

  EditOwnershipClicked() {
    this.popupVisible = true;
  }

  FindCoordinates() {
    this.FindLatLong();
  }

  FindLatLong() {
    const result = this.provinceDataSource.filter(obj => {
      return obj.statProvId === this.SiteData.statProvId;
    });
    this.isLoadPanelVisible = true;
    var geo = new GeocodeRequest();
    geo.Address = this.SiteData.address;
    geo.City = this.SiteData.city;
    geo.State = result[0].provinceId;
    geo.CountryCode = this.SiteData.countryId;
    if (this.SiteData.zipCode) {
      geo.PostalCode = this.SiteData.zipCode;
      geo.excludePostCode = false;
    }
    else {
      geo.PostalCode = null;
      geo.excludePostCode = true;
    }
    this.siteSvc.getLatLong(geo).subscribe({
      next: data => {
        this.Coordinates = data;
        this.isLoadPanelVisible = false;
        this.mapsPopupVisible = true;
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Coordinates", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  savecordinates(e) {
    this.Coordinates = e;
    this.mapsPopupVisible = false;
    this.updateSiteDataForMaps(this.Coordinates);
  }

  updateSiteDataForMaps(e) {
    if (e.latitude && e.longitude) {
      let latlngStr = e.latitude + "," + e.longitude;
      let geocoder = new google.maps.Geocoder();
      let latlng = new google.maps.LatLng(e.latitude, e.longitude);
      let request = { location: latlng };
      geocoder.geocode(request, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results != null) {
            if (results && results.length > 0 && results[0].address_components && results[0].address_components.length > 0) {
              let addComponent;
              results.forEach(element => {
                if (element.address_components.filter(x => x.types.includes("administrative_area_level_1")).length > 0 && element.address_components.filter(x => x.types.includes("country")).length > 0 && element.address_components.filter(x => x.types.includes("locality")).length > 0) {
                  addComponent = element;
                }
              });
              if (addComponent) {
                let component = addComponent.address_components.filter(x => x.types.includes("locality"));
                if (component && component.length > 0) {
                  this.SiteData.city = component[0].long_name;
                }
                component = addComponent.address_components.filter(x => x.types.includes("administrative_area_level_1"));
                if (component && component.length > 0) {
                  if (this.provinceArray.filter(x => x.province == component[0].long_name).length > 0) {
                    this.SiteData.statProvId = this.provinceArray.filter(x => x.province == component[0].long_name)[0].statProvId;
                  }
                  else {
                    this.SiteData.statProvId = this.provinceArray.filter(x => x.province == "_Not assigned")[0].statProvId;
                  }
                }
                component = addComponent.address_components.filter(x => x.types.includes("country"));
                if (component && component.length > 0) {
                  this.SiteData.countryId = component[0].short_name;
                }
                this.message = "The country, state and city will be updated to reflect the chosen latitude and longitude.";
                this.eventkey = "maps";
                this.okayCancelDialogVisible = true;
              } else {
                this.setWarningForLatLong();
              }
            }
            else {
              this.setWarningForLatLong();
            }
          }
          else {
            this.setWarningForLatLong();
          }
        }
        else {
          this.notificationService.alert("error", "Error while Reverse Geocoding", null);
          this.isLoadPanelVisible = false;
        }
      });
    }
    else {
      this.setWarningForLatLong();
    }

  }

  setWarningForLatLong() {
    this.SiteData.latitude = null;
    this.SiteData.longitude = null;
    this.SiteData.altitudeFeet = null;
    this.notificationService.alert("warning", "Location details should be correct to get latitude and longitude.", null);
  }


  OnSaveClicked() {
    this.isLoadPanelVisible = true;
    if (this.SAPgridBoxValue && this.SAPgridBoxValue.length > 0 && this.SAPgridBoxValue[0] !== null) {
      this.ProductionData.sapplantId = this.SAPgridBoxValue[0].toString();
    }
    if (this.gasFlagForGeoCalcuation === true && this.isLatitudeChanged === true) {
      this.ProductionData.geoCalculation = true;
    }
    this.SavePlantInfo();

  }

  validatePlantType(e) {
    if (this.SiteData.plantBusiness == "M" || this.SiteData.plantBusiness == "B") {
      return this.ProductionData.linflag || this.ProductionData.loxflag == true || this.ProductionData.larflag == true || this.ProductionData.lhyflag == true || this.ProductionData.bhyflag == true || this.ProductionData.co2flag == true || this.ProductionData.gcO2Flag == true || this.ProductionData.lheFlag == true;
    } else {
      return true;
    }
  }

  OnSaveCloseClicked() {
    this.isSaveCloseClicked = true;
    this.OnSaveClicked();
  }

  OnDiscardCloseClicked() {
    this.NavigateTopreviousPage();
  }

  NavigateTopreviousPage() {
    if (this.sharedSvc.previousRouteToEditSite) {
      if (this.sharedSvc.previousRouteToEditSite.includes("sitesummary")) {
        this.router.navigate(["/sitesummary/" + this.siteId]);
      } else if (this.sharedSvc.previousRouteToEditSite.includes("pipelines")) {
        this.router.navigate([this.sharedSvc.previousRouteToEditSite])
      } else if (this.sharedSvc.previousRouteToEditSite.includes("refinerybalance")) {
        this.router.navigate([this.sharedSvc.previousRouteToEditSite])
      } else if (this.sharedSvc.previousRouteToEditSite.includes("facility")) {
        this.router.navigate([this.sharedSvc.previousRouteToEditSite])
      }
      else {
        this.router.navigate(["/plants"]);
      }
    }
  }

  SavePlantInfo() {
    this.SiteData.activeFlag = "true";
    this.PlantInfo.SiteData = this.SiteData;
    this.PlantInfo.ProductionData = this.ProductionData;
    this.PlantInfo.ProductionData.siteId = this.siteId;
    this.PlantInfo.realPlant = this.realPlant;
    this.validateProducts();
    if (!this.productsValidated || !this.companyOwnershipAdded) {
      this.isLoadPanelVisible = false;
      return;
    } else {
      this.isLoadPanelVisible = true;

      // Only check for duplicates when creating new sites
      if (this.isNewSite) {
        this.siteSvc.CheckSiteExists(this.PlantInfo).subscribe({
          next: data => {
            if(data) {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("warning", "The Site Name already exists.", null);
                return;
              }
            this.saveSiteData();
          }, error: (error) => {
            this.notificationService.alert("error", "Error while checking if the site already exists", error);
            this.isLoadPanelVisible = false;
          }
        });
      } else {
        // For existing sites, skip duplicate check and save directly
        this.saveSiteData();
      }
    }
  }

  private saveSiteData() {
    this.siteSvc.SaveSite(this.PlantInfo).subscribe({
      next: data => {
        this.siteId = data;
        this.isLoadPanelVisible = false;
        this.SaveProduction();
      }, error: (error) => {
        this.notificationService.alert("error", "Error while saving plant data", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  validateProducts() {
    if ((this.SiteData.plantBusiness == 'M' || this.SiteData.plantBusiness == 'B') && this.ProductionData.plantStatus === 'Real' &&
      !(this.ProductionData.linflag || this.ProductionData.loxflag || this.ProductionData.larflag ||
        this.ProductionData.lhyflag || this.ProductionData.bhyflag || this.ProductionData.co2flag || this.ProductionData.gcO2Flag)) {
      this.productsValidated = false;
    } else {
      this.productsValidated = true;
    }

    if (this.CompanySiteData && this.CompanySiteData.length == 0) {
      this.companyOwnershipAdded = false;
    } else {
      this.companyOwnershipAdded = true;
    }
  }

  SaveProduction() {
    // Apply shutdown flag logic before saving
    this.applyShutdownFlagLogic();

    if (this.ProductionData.loxflag == true && this.ProductionData.linflag && this.ProductionData.capacityUOM == "shortTPD") {
      this.ProductionData.capacityUOM = "MTD";
      this.ProductionData.capacity = this.ConvertUnit("MTD", "capacity");
    }
    if (this.ProductionData.larflag == true && this.ProductionData.laR_TPDUOM == "shortTPD") {
      this.ProductionData.laR_TPDUOM = "MTD";
      this.ProductionData.larTpd = this.ConvertUnit("MTD", "larTpd");
    }
    if (this.ProductionData.lhyflag == true && this.ProductionData.lhyVolumeTPDUOM == "shortTPD") {
      this.ProductionData.lhyVolumeTPDUOM = "MTD";
      this.ProductionData.lhyvolumeTpd = this.ConvertUnit("MTD", "lhyvolumeTpd");
    }
    if (this.ProductionData.bhyflag == true && this.ProductionData.bHy_knm3hUOM == "shortTPD") {
      this.ProductionData.bHy_knm3hUOM = "MTD";
      this.ProductionData.bhyKnm3h = this.ConvertUnit("MTD", "bhyKnm3h");
    }
    if (this.ProductionData.co2flag == true && this.ProductionData.cO2VolumeTPDUOM == "shortTPD") {
      this.ProductionData.cO2VolumeTPDUOM = "MTD";
      this.ProductionData.co2volumeTpd = this.ConvertUnit("MTD", "co2volumeTpd");
    }
    if (this.ProductionData.gcO2Flag == true && this.ProductionData.gcO2VolumeTPDUOM == "shortTPD") {
      this.ProductionData.gcO2VolumeTPDUOM = "MTD";
      this.ProductionData.gcO2VolumeTPD = this.ConvertUnit("MTD", "gcO2VolumeTPD");
    }
    if (this.ProductionData.siteId > 0) {
      this.siteSvc.SaveProduction(this.ProductionData).subscribe({
        next: data => {
          this.ProductionData = data;
          this.isLoadPanelVisible = false;
          this.notificationService.alert("success", "Plant details saved successfully.", null);
          if (this.isSaveCloseClicked) {
            this.NavigateTopreviousPage();
          } else {
            this.router.navigate(["/editsite/" + data.siteId]);
          }
        }, error: (error) => {
          this.notificationService.alert("error", "Error while saving plant production data", error);
          this.isLoadPanelVisible = false;
        }
      });
    }
    else {
      this.ProductionData.activeFlag = true;
      this.ProductionData.siteId = this.siteId;
      this.siteSvc.addNewProduction(this.ProductionData).subscribe({
        next: data => {
          this.ProductionData = data;
          this.isLoadPanelVisible = false;
          this.notificationService.alert("success", "Plant details saved successfully.", null);
          if (!this.isSaveCloseClicked) {
            this.router.navigate(["/editsite/" + data.siteId]);
          } else {
            this.NavigateTopreviousPage();
          }
        }, error: (error) => {
          this.notificationService.alert("error", "Error while saving plant production data", error);
          this.isLoadPanelVisible = false;
        }
      });
    }
  }

  latitudeChanged() {
    this.isLatitudeChanged = true;
  }

  OnDeleteClicked() {
    if (this.sharedSvc.isFacilityLinked) {
      this.message = "There are active facilities associated with this plant. Are you sure you want to delete the associated facilities as well?";
    } else {
      this.message = "Site will be permanently deleted. Do you wish to continue";
    }

    this.eventkey = "deleteSiteAsync";
    this.okayCancelDialogVisible = true;
  }

  DeleteSite() {
    this.isLoadPanelVisible = true;
    this.siteSvc.DeleteSite(this.siteId).subscribe({
      next: data => {
        this.notificationService.alert("success", "Site Deleted Successfully.", null);
        this.isLoadPanelVisible = false;
        setTimeout(() => { this.router.navigate(["/plants"]); }, 3000);
      }, error: (error) => {
        this.notificationService.alert("error", "Error while deleting plant data", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  DeleteSiteAsync() {
    this.isLoadPanelVisible = true;
    this.batchReportsService.deleteSiteAsync(this.siteId).subscribe({
      next: data => {
        this.notificationService.alert("success", "Delete Site Request submitted successfully and will be deleted in the next few minutes. Please wait for some time (~ 5 minutes) before accessing the site related content.", null);
        this.isLoadPanelVisible = false;
        setTimeout(() => { this.router.navigate(["/plants"]); }, 6000);
      }, error: (error) => {
        this.notificationService.alert("error", "Error while deleting plant data", error);
        this.isLoadPanelVisible = false;
      }
    });
  }

  setPopupVisibility(data) {
    this.popupVisible = data;
  }

  setmapsPopupVisibility(isVisible) {
    this.mapsPopupVisible = isVisible;
  }

  setCompanySites(data) {
    this.PlantInfo.CompanySites = data;
    this.CompanySiteData = data;
  }

  setProdVolHistoryData(data) {
    this.PlantInfo.Prodvolhistories = data;
  }

  createCompanySiteForNewSite(data: boolean) {
    this.createCompanySite = data;
  }

  setVolumePopupVisibility(isVisible) {
    this.volumePopupVisible = isVisible;
  }

  setProductionData(production) {
    this.ProductionData = production;
  }

  setGasFlagForGeoCalcuation(gasFlag) {
    this.gasFlagForGeoCalcuation = gasFlag;
  }

  ProcessresultFromdialog(e) {
    if (e.isOkayClicked) {
      if (e.eventkey == "maps") {
        this.SiteData.latitude = this.Coordinates.latitude;
        this.SiteData.longitude = this.Coordinates.longitude;
        this.SiteData.altitudeFeet = this.Coordinates.altitude;
      }
      if (e.eventkey == "deleteSite") {
        this.DeleteSite();
      }

      if (e.eventkey === "deleteSiteAsync") {
        this.DeleteSiteAsync();
      }
    }
    this.okayCancelDialogVisible = false;
  }

  EditVolumeClicked() {
    this.volumePopupVisible = true;
  }

  setIsClose(isClose) {
    this.isSaveCloseClicked = isClose;
    this.isSubmitClicked = true;
  }

  applyShutdownFlagLogic() {
    let shouldBeActive: boolean;

    if (this.ProductionData.shutdownDate) {
      const shutdownDate = new Date(this.ProductionData.shutdownDate);
      const currentDate = new Date();

      shouldBeActive = shutdownDate > currentDate;
    } else {
      shouldBeActive = true;
    }

    // Only update if the value would actually change
    if (this.ProductionData.activeFlag !== shouldBeActive) {
      this.ProductionData.activeFlag = shouldBeActive;

      if (!shouldBeActive) {
        // Show notification that site will be marked as inactive
        this.notificationService?.alert("info", "Site will be marked as inactive due to shutdown date being in the past.", null);
      }
    }

    // If "Is Dismantled" OR "Is not yet started up, is shutdown..." is selected
    // Then activeFlag should be false
    if (this.ProductionData.dismantledFlag || this.ProductionData.shutDownFlag) {
      this.ProductionData.activeFlag = false;
    }
  }
}
